/**
 * User-facing messages for transient toasts. Defined once in the shared `common`
 * layer and reused across core and feature surfaces so the same wording is never
 * duplicated as an inline string literal.
 */
export enum ToastMessage {
  Saved = 'Saved',
  /** No connection at all — said instead of "Server error" when the device
   *  reports itself offline. The whole message: anything longer only restates
   *  what the user already knows. */
  Offline = "You're offline",
}
